<ll-titulo *ngIf="showTitle">{{ universidad.universidad }}</ll-titulo>
<universidad [universidadId]="universidadId" (universidadEvent)="setUniversidad($event)"></universidad>
